module.exports = __webpack_public_path__ + "img/werther-zh.9aae1934.jpg";